// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress-bar-container[data-v-c55e1cb4] {\n  width: 100%;\n  height: 4px;\n  background-color: rgba(51, 51, 50, 0.1);\n}\n.progress-bar[data-v-c55e1cb4] {\n  width: 0;\n  height: 4px;\n  transition: width 0.3s ease;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
